module.exports = __webpack_public_path__ + "static/img/giant_normal.d64597d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/downgrade-animation/images/giant_normal.svg
// module id = rfjc
// module chunks = 12